import { useSearchParams } from 'react-router-dom';

export const SETUP_BACK_URL_PARAM = 'setupBackURL';

// Carries the setup flow's exit URL (e.g. Wi-Fi settings) across every step, so stepping back
// through the flow eventually returns to where it was started from instead of device-register.
export function useSetupBackUrl() {
  const [search] = useSearchParams();
  const setupBackURL = search.get(SETUP_BACK_URL_PARAM);

  function withSetupBackUrl(path: string) {
    if (!setupBackURL) return path;
    const separator = path.includes('?') ? '&' : '?';
    return `${path}${separator}${SETUP_BACK_URL_PARAM}=${encodeURIComponent(setupBackURL)}`;
  }

  return { setupBackURL, withSetupBackUrl };
}
